import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { dateIt } from "@/lib/format";
import { AlertTriangle } from "lucide-react";

export function AvvisoOreMancanti() {
  const { data = [] } = useQuery({
    queryKey: ["controllo-giornaliero"],
    queryFn: async () => (await api.get("/ore/controllo-giornaliero")).data,
  });
  if (data.length === 0) return null;
  return (
    <div className="bg-amber-50 border border-amber-300 text-amber-900 rounded-xl px-4 py-3 text-sm" data-testid="avviso-ore-mancanti">
      <div className="flex items-center gap-2 font-semibold mb-2">
        <AlertTriangle className="h-5 w-5 text-amber-600" /> Ore giornaliere incomplete nei giorni lavorativi dal 01/10/2026
      </div>
      <ul className="space-y-1">
        {data.map((d) => (
          <li key={d.dipendente_id} data-testid={`avviso-ore-${d.codice}`}>
            <b>{d.nome}</b>:{" "}
            {d.giorni.map((g) => `${dateIt(g.data)} (${g.ore} h)`).join(", ")}
          </li>
        ))}
      </ul>
    </div>
  );
}
